module.exports = __webpack_public_path__ + "static/media/b3_p16_clickable_ph.54767c88.png";